import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { getOrderParameters, Orders } from '@europrocurement/l2d-domain/utils/orders';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    CatalogueApi,
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull,
    CatalogueApiApiCataloguesAdminOffresGetCollectionRequest,
} from '../../../openApi/ApiOffre';
import { CATALOGS_ADMIN_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type CatalogsAdminApiObject =
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull;

export type CatalogsAdmin = CatalogsAdminApiObject;

export const mapperCatalogsAdmin = function (catalogs: CatalogsAdminApiObject) {
    return {
        ...catalogs,
    } as CatalogsAdmin;
};

export function createCatalogsAdminSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CatalogueApi(conf);

    // apiPrescripteursCataloguesGetCollection
    const fetchCatalogsCollection: FetchCollectionData<CatalogsAdminApiObject> = ({
        search,
        pagination: { page, itemsPerPage },
        xIdSociete,
        filters,
        orders,
    }) => {
        /** Field mapper : Map column field name with api filter name */
        const ordersSchema = {
            groupement: 'groupementLibelle',
        };

        /** Get collection default orders */
        const defaultOrders: Orders = {
            orderGroupementRang: 'asc',
            orderPackageFormaliteLibelle: 'asc',
        };

        const orderParameters = getOrderParameters(orders, defaultOrders, ordersSchema);

        let multiFieldSearch;

        /**
         * Manage search filters.
         */
        if (search && search !== '') {
            multiFieldSearch = search;
        }

        const requestParameters: CatalogueApiApiCataloguesAdminOffresGetCollectionRequest = {
            page: page + 1,
            itemsPerPage,
            ...filters,
            domaineSocietesSocieteId: xIdSociete,
            ...orderParameters,
            multiFieldSearch,
        };

        return api
            .apiCataloguesAdminOffresGetCollection(requestParameters)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<CatalogsAdminApiObject>>;
    };

    const fetchCatalogsItem: FetchItemDataType<CatalogsAdminApiObject> = ({ idItem }) =>
        api
            .apiCataloguesIdGet({ id: String(idItem) })
            .then((res) => res.data) as Promise<CatalogsAdminApiObject>;

    const { slice: catalogsAdminSlice, dataSourcesThunks: catalogsAdminDataSourcesThunks } =
        SliceFactory.createSlice<CatalogsAdminApiObject, CatalogsAdmin>(
            CATALOGS_ADMIN_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [],
            fetchCatalogsCollection,
            fetchCatalogsItem,
            mapperCatalogsAdmin,
        );

    return { catalogsAdminSlice, catalogsAdminDataSourcesThunks };
}
